import React from 'react';
import PropTypes from 'prop-types';

import {
  Bar,
  CartesianGrid,
  Legend,
  Line,
  ComposedChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import styles from './ordersReviewChart.module.scss';

const OrdersReviewChart = ({ data, viewMode, onUnsuccessfulBarClick }) => {
  const handleUnsuccessfulBarClick = barState => {
    if (typeof onUnsuccessfulBarClick !== 'function') {
      return;
    }

    const payload =
      barState && typeof barState === 'object' && barState.payload
        ? barState.payload
        : barState;

    onUnsuccessfulBarClick(payload);
  };

  return (
    <ResponsiveContainer width="100%" height={380}>
      <ComposedChart data={data}>
        <CartesianGrid strokeDasharray="3 3" className={styles.chartGrid} />
        <XAxis
          dataKey="date"
          label={{ value: 'Mėnesio diena', position: 'insideBottomRight' }}
          className="text-xs"
        />
        <YAxis
          label={{
            value: viewMode === 'orders' ? 'Užsakymai' : 'Apyvarta (EUR)',
            angle: -90,
            position: 'insideLeft',
            offset: 20,
          }}
          className="text-xs"
        />
        <Tooltip
          content={props => {
            if (!props.payload) return null;
            return (
              <div className={styles.monitoringChartTooltipContainer}>
                <div className={styles.monitoringChartTooltipContent}>
                  <span className={styles.monitoringChartTooltipContentName}>
                    Mėnesio diena
                  </span>
                  <span className={styles.monitoringChartTooltipContentValue}>
                    {props.label}
                  </span>
                </div>
                {props.payload.map((payload, i) => {
                  return (
                    <div
                      key={i}
                      className={styles.monitoringChartTooltipContent}
                    >
                      <span
                        className={styles.monitoringChartTooltipContentName}
                      >
                        {payload.name}
                      </span>
                      <span
                        className={styles.monitoringChartTooltipContentValue}
                        style={{ color: payload.color }}
                      >
                        {viewMode === 'orders'
                          ? `${payload.value} užsakymai`
                          : `€${payload.value.toFixed(2, 10)}`}
                      </span>
                    </div>
                  );
                })}
              </div>
            );
          }}
        />
        <Legend iconType="circle" />
        <Bar
          dataKey={
            viewMode === 'orders'
              ? 'successful_order_count'
              : 'successful_revenue'
          }
          stackId="a"
          fill="#1AA64C"
          name="Sėkmingi"
        />
        <Bar
          dataKey={
            viewMode === 'orders'
              ? 'unsuccessful_order_count'
              : 'unsuccessful_revenue'
          }
          stackId="a"
          fill="#FF3B30"
          name="Nesėkmingi"
          cursor={viewMode === 'orders' ? 'pointer' : 'default'}
          onClick={handleUnsuccessfulBarClick}
        />
        <Line
          type="monotone"
          dataKey={
            viewMode === 'orders' ? 'lastResultOrders' : 'lastResultRevenue'
          }
          stroke="#005FDB"
          strokeWidth={2}
          name="Praeitais metais ta pati diena"
          dot={false}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

OrdersReviewChart.propTypes = {
  data: PropTypes.array.isRequired,
  viewMode: PropTypes.oneOf(['orders', 'revenue']).isRequired,
  onUnsuccessfulBarClick: PropTypes.func,
};

export default OrdersReviewChart;
